<main>
    <div class="d-grid gap-4 faq-category-page">
        <div class="eventType-head flex-wrap gap-2">
            <div class="d-flex align-items-center gap-3" style="cursor: pointer;" (click)="goBack()">
                <i class="fas fa-arrow-left back-icon"></i>
                <div class="eventType-text">
                    FAQ categories
                </div>
            </div>
            <div class="buttonContainer">
                <!-- <div> -->
                    <div class="search-container">
                        <div class="search-icon">
                            <img src="assets/icons/side-bar/search-normal.svg" alt="search"
                                style="width: 18px; height: 18px;" />
                        </div>
                        <input type="text" placeholder="Search here..." class="search-input" [(ngModel)]="search"
                            (input)="updateSearch(search)" (keyup.enter)="applyFilter()" autocomplete="off" />
                    </div>
                <!-- </div> -->
            </div>
        </div>

        <!-- Section Tabs -->
        <div class="faq-section-tabs">
            <button
                *ngFor="let section of sections"
                class="section-tab"
                [class.active]="activeSection === section.audienceType"
                (click)="setSection(section.audienceType)">
                {{ section.label }}
            </button>
        </div>

        <div class="d-flex align-items-center justify-content-between">
            <div class="header-text">
                Manage categories
            </div>

            <app-button label="Add category"  *ngIf="userRoles.addNew"  [minWidth]="'12rem'" [bgcolor]="'rgba(0, 0, 0, 0.15)'"
                (clicked)="openAddCategory()">
            </app-button>
        </div>

        <!-- Loading State -->
        <!-- <div *ngIf="isLoading" class="loading-container">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <div class="loading-text">Loading categories...</div>
        </div> -->

        <!-- Empty State -->
        <div *ngIf="!isLoading && filteredCategories.length === 0" class="faq-card">
            <div class=" pb-3">
                <div class="empty-state">
                    <i class="far fa-file-alt"></i>
                    <h4>No FAQ categories found</h4>
                </div>
            </div>
        </div>

        <!-- Dynamic FAQ Cards -->
        <div class="max-content">
            <div *ngFor="let category of filteredCategories; let i = index" class="faq-card"
                [class.faq-card-expanded]="category.isOpen">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="header-text">
                        {{ category.name }}
                    </div>
                    <div class="d-flex gap-2">
                        <button class="edit-btn" *ngIf="userRoles.listItem.edit" title="Edit" (click)="editCategory(category)">
                            <img class="action-button" src="assets/images/Buttons/edit-button.svg" alt="Edit" />
                        </button>
                        <button class="delete-btn" *ngIf="userRoles.listItem.delete"  title="Delete" (click)="deleteCategory(category.id)">
                            <img class="action-button" src="assets/images/Buttons/delete-button.svg" alt="Delete" />
                        </button>
                        <!-- <button class="arrow-btn" title="Toggle Details" (click)="toggleCategory(i)">
                             <img class="action-button" [class.rotated]="category.isOpen"
                                 src="assets/images/Buttons/arrow.svg" alt="Toggle" />
                         </button> -->
                    </div>
                </div>

                <!-- Collapsible FAQ Details -->
                <!-- <div *ngIf="category.isOpen" class="faq-details-container" @slideInOut>
                     <div *ngIf="category.faqs.length === 0" class="no-faqs-message">
                         No FAQs available for this category.
                     </div>
                     <div *ngFor="let faq of category.faqs" class="faq-details-card">
                         <div class="faq-question">{{ faq.question }}</div>
                         <div class="faq-answer">{{ faq.answer }}</div>
                     </div>
                 </div> -->
            </div>
        </div>
    </div>
</main>